import type { InjectionKey, Ref } from "vue";

interface Toggle {
  register: (value: unknown, el: Ref<HTMLElement | null>) => void;
  unregister: (value: unknown) => void;
  active: Ref<unknown>;
}

export const toggleKey: InjectionKey<Toggle> = Symbol("toggle");
